<template>
  <button
    class="community-cta community-cta--centered"
    data-test-id="create-thread-community-cta"
    @click="tryToStartDiscussion"
  >
    <img
      src="/common/nexus/forums-cta.png"
      alt=""
      class="community-cta__img"
      data-test-id="create-thread-cta-image"
    >
    <span class="community-cta__content">
      <span class="community-cta__text">
        Looking for answers?
      </span>
      <span class="community-cta__direction">
        Start a discussion
        <icon-component
          name="caret"
          title="caret icon"
          class="community-cta__icon icon--smallest"
        />
      </span>
    </span>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CreateThreadCta',
  computed: {
    ...mapGetters([
      'userIsLoggedIn',
      'userIsUnverified',
    ]),
  },
  methods: {
    tryToStartDiscussion(event) {
      if (this.userIsLoggedIn && !this.userIsUnverified) {
        this.$snowplow.trackButtonEvent({
          data: {
            type: 'forum',
            text: event.target.textContent.trim(),
            classes: event.target.classList,
            id: event.target.id,
          },
        });
      }
      this.$router.push({ name: 'createThread' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_community-cta';
</style>

<docs>
</docs>
